$mol_icon_align_horizontal_center $mol_icon path \M11 2H13V7H21V10H13V14H18V17H13V22H11V17H6V14H11V10H3V7H11V2Z
